export const TextEffectsGlitchViewerType = 'wixui.TextEffectsGlitch' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsGlitch-container',
    text: 'TextEffectsGlitch-text',
  },
} as const;
